import { Clock3, CircleX, SquarePen } from "lucide-react";
import { Reveal } from "./Reveal";
import { SectionHeading } from "./SectionHeading";
import copy from "@/content/homepage-copy.json";

const ICON = { Clock3, CircleX, SquarePen };

export const ProblemSection = () => {
  const p = copy.problem;
  return (
    <section className="mx-auto max-w-content px-4 py-14 md:px-8 md:py-[88px]" data-testid="problem-section">
      <SectionHeading chapter={p.eyebrow} title={p.title} lead={p.lead} size="lg" />

      <div className="mt-14 grid grid-cols-1 gap-5 md:grid-cols-3">
        {p.items.map((item, i) => {
          const Icon = ICON[item.icon] || Clock3;
          return (
            <Reveal key={item.title} delay={i * 0.1}>
              <div className="group hover-glow h-full min-h-[190px] rounded-card border border-brand-line bg-brand-surface p-7 hover:-translate-y-1">
                <div className="mb-6 inline-flex h-12 w-12 items-center justify-center rounded-field border border-brand-line text-brand-accent transition-transform duration-300 group-hover:-translate-y-1">
                  <Icon size={24} strokeWidth={1.75} aria-hidden="true" />
                </div>
                <h3 className="font-display text-lg font-semibold text-brand-text">{item.title}</h3>
                <p className="mt-3 text-[15px] leading-relaxed text-brand-sec">{item.text}</p>
              </div>
            </Reveal>
          );
        })}
      </div>

      {/* most do porównania „przed i po" */}
      <Reveal delay={0.15}>
        <a
          href="#efekty"
          data-testid="problem-bridge"
          className="glow-strong mt-8 block rounded-panel border border-brand-accent/30 bg-brand-elevated p-8 text-center transition-transform duration-200 hover:-translate-y-0.5"
        >
          <p className="text-[15px] text-brand-sec">{p.bridgePre}</p>
          <p className="mt-1 font-display text-2xl font-semibold text-brand-text sm:text-3xl">
            {p.bridgeMain.replace(/\.$/, "")}
            <span className="text-brand-accent">.</span>
          </p>
          <p className="mt-3 inline-flex items-center gap-1.5 font-display text-xs font-bold uppercase tracking-[0.08em] text-brand-accent">
            {p.bridgeLink} <span aria-hidden="true">↓</span>
          </p>
        </a>
      </Reveal>
    </section>
  );
};
